export default __webpack_public_path__ + "static/media/Parallax-HUD-05.916c7a1d.jpg";